module.exports = __webpack_public_path__ + "static/media/Nymphadora Tonks 2.ffcf178f.jpg";